import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class LoginByPin extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        loginByPin: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    render() {
        const {loginByPin, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-black text-left">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.pin.title}</span>
                        <span className="settings-name-info">{msg.settings.pin.subtitle}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div className={`switch-option text-l ${loginByPin ? 'active' : ''} color-greenLight`}
                             onClick={() => changeDeviceSettings('loginByPin', true)}>
                            <div className="switch-inner">
                                <span>{msg.settings.allow}</span>
                            </div>
                        </div>
                        <div className={`switch-option text-l ${loginByPin ? '' : 'active'} color-red`}
                             onClick={() => changeDeviceSettings('loginByPin', false)}>
                            <div className="switch-inner">
                                <span>{msg.settings.deny}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    loginByPin: state.device.loginByPin
}), {changeDeviceSettings})(LoginByPin);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/LoginByPin.js